import { render, staticRenderFns } from "./LoyaltyPointScanDetailViewMobilePreview.vue?vue&type=template&id=7af2b5d2&scoped=true&"
import script from "./LoyaltyPointScanDetailViewMobilePreview.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointScanDetailViewMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointScanDetailViewMobilePreview.vue?vue&type=style&index=0&id=7af2b5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2b5d2",
  null
  
)

export default component.exports